<template>
    <div class="load-more-wrap">
        <div v-if="loadMore==true" class="more-box">
            <div class="more-btn" @click="handleLoadmore">加载更多<i class="el-icon-arrow-down"></i></div>
        </div>
        <div v-else class="more-box">
            <div class="empty-data">已经到底了~~</div>
        </div>
    </div>
  </template>
  
  <script>  
  
    export default {
      components: { },
      props: {
        loadMore: null,
      },
      data() {
          return {
  
          };
        },
      methods: {
        handleLoadmore(){
            this.$emit('loadmore');
        },
      },
      created() {},
      mounted() {}
    };
  </script>
  
  <style scoped>
  .load-more-wrap{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: stretch;    
  }
  .more-box{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;
    gap: 2px;
    padding: 20px 0px;
  }
  .more-btn{
    font-size: 16px;
    font-weight: normal;
    line-height: 17px;
    letter-spacing: 0em;
    color: #000000;    
    margin: 5px;
    cursor: pointer;
  }
    .more-btn:hover{
        color:#014289;
    }
  .empty-data{
    font-size: 14px;
    font-weight: normal;
    line-height: 17px;
    color: #909399;
    
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/basic/loadmore/index.vue